module.exports = __webpack_public_path__ + "fd5a608a/img/22000000-0.3e8ca691.png";